import {default as app} from '@legacy/App';
import { environment } from 'src/environments/environment';


app.constant('settings', {
	// Please add new URL's in alphabetical order.
	AdditionalFieldsURL: 'AdditionalFields', 
    ApiURL: environment.endpoint.api,
	AuditLogURL: 'auditlog',
	BankAccountURL: 'bankaccount',
	CompanyURL: 'company',	
	ConfigurationURL: 'configuration',
	ConfigurationSetURL: 'configurationset',
	ConfigurationGroupURL: 'configurationgroup',
	CustomerURL: 'customer',	
	DataAreaURL: 'dataarea',
	StrappingChartProfilesURL:'strappingchartprofiles',
	DeviceProductGroupURL: 'deviceproductgroup',
	DeviceURL: 'device',
	DeviceProductURL: 'deviceproduct',
	DriverURL: 'driver',
	ExportURL: 'export',	
	FactorURL: 'factor',
	FleetURL: 'fleet',
	GridMarginHeight: 120,	
	LoadPointURL: 'loadpoint',	
	LoginURL: 'login',
	MasterDataURL: 'masterdata',
	PaymentTermsURL: 'paymentterms',
	PriceGroupURL: 'specialpricegroup',
	ProductURL: 'product',
	ProductCategoriesURL: 'product-category',
	ProductGroupURL: 'productgroup',	
	SafetyCheckURL: 'safetycheck',
	SpecialPriceURL: 'specialprice',
	SpecialPriceGroupURL: 'specialpricegroup',
	TimeLogURL: 'timelog',
	ToastDuration: 4000,	
	UnloadPointURL: 'unloadpoint',	
	UserURL: 'user',	
	VehicleURL: 'vehicle',
	ModulesURL: 'modules',
	LoadPointTankUrl: 'loadpointtank'
});

